import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { WithdrawalRequestDto } from '../../domain/contracts/api.contracts';
import {
  getPayoutOptions,
  getWithdrawalHistory,
  requestWithdrawal,
  type WithdrawalHistoryParams,
} from '../../infrastructure/api/withdrawalsApi';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E19 — GET /withdrawals/history (paged + status filter). */
export function useWithdrawalHistory(params: WithdrawalHistoryParams = {}) {
  return useQuery({
    queryKey: qKeys.withdrawals.history(params),
    queryFn: () => getWithdrawalHistory(params),
    ...queryDefaults,
    placeholderData: (prev) => prev,
  });
}

/** GET /withdrawals/payout-options — saved payout rails (masked) the member can choose from. */
export function usePayoutOptions() {
  return useQuery({
    queryKey: qKeys.withdrawals.payoutOptions,
    queryFn: getPayoutOptions,
    ...queryDefaults,
  });
}

/** E14 — POST /withdrawals/request { amount, method } (BKASH | BANK_EFT). */
export function useWithdrawalRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ body, idempotencyKey }: { body: WithdrawalRequestDto; idempotencyKey?: string }) =>
      requestWithdrawal(body, idempotencyKey),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qKeys.withdrawals.all });
      void queryClient.invalidateQueries({ queryKey: qKeys.dashboard });
      void queryClient.invalidateQueries({ queryKey: qKeys.commissions.summary });
    },
  });
}
